import { render, staticRenderFns } from "./SurveyScopeControlsSection.vue?vue&type=template&id=6cc7c9b3"
import script from "./SurveyScopeControlsSection.vue?vue&type=script&lang=js"
export * from "./SurveyScopeControlsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports